import React, {Component} from "react";
import { UncontrolledTooltip} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import moment from "moment";
import {deepCopyObject, showAxiosError, toFixedNumber} from "../../../helper/helper";
import {validateComponent, validateField} from "../../../common/validation";
import Alert from "react-s-alert";
import NumberFormat from "react-number-format";
import Datetime from "react-datetime";
import Select from "../../../local_node_modules/react-select";
import {defterUnitName, defterUnitNameShort} from "../../../helper/permission";
import {EntegratorConf} from "../../../constants";

let valid = function (current, date, name) {
    if (name === 'startDate') {
        return moment(current).isSameOrBefore(moment(date));
    }
    if (name === 'expireDate') {
        return moment(current).isSameOrAfter(moment(date));
    }
    return false;
}

class DistributorPriceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            priceList: [],
            error: {},
        }
        this.fetchList = this.fetchList.bind(this);
        this.addNewLine = this.addNewLine.bind(this);
        this.closeDistributorPriceListModal = this.closeDistributorPriceListModal.bind(this);
        this.save = this.save.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.handleEditDates = this.handleEditDates.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    componentDidMount() {
        this.fetchList();
    }

    fetchList() {
        let self = this;
        let url = '/customer/findPriceList/' + this.props.customer.recordId;
        let params = {
            url: url,
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                let priceList = response.data;
                if (Array.isArray(priceList) && priceList.length === 0) {
                    priceList.push({
                        recordId: null,
                        createdBy: self.props.currentUser.customerId,
                        startDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
                        updatedAt: moment().format("YYYY-MM-DDTHH:mm:ss"),
                        createdAt: moment().format("YYYY-MM-DDTHH:mm:ss"),
                        price: 0,
                        quantity: 0,
                        unit: 1,
                    })
                }
                self.setState({priceList, isLoading: false});
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({isLoading: false})
            });
    }

    addNewLine() {
        let priceList = deepCopyObject(this.state.priceList);
        priceList.push({
            recordId: null,
            createdBy: this.props.currentUser.customerId,
            startDate: null,
            updatedAt: null,
            createdAt: null,
            price: 0,
            quantity: 0,
            unit: 1
        })
        this.setState({priceList});
    }

    closeDistributorPriceListModal() {
        this.props.toggle()
    }

    save() {
        let self = this;
        let isValid = self.validateComponent();
        if (isValid.valid) {
            let url = '/customer/savePriceList';
            let params = {
                url: url,
                method: "post",
                data: {
                    priceList: self.state.priceList,
                    customerId: self.props.customer.recordId,
                }
            };
            self.setState({isLoading: true});
            request(params)
                .then(function (response) {
                    self.setState({isLoading: false}, () => self.fetchList());
                    Alert.success("Fiyat Listesi Başarıyla Kaydedildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                }).catch(function (error) {
                showAxiosError(error);
                self.setState({isLoading: false})
            });
        } else {
            let message = "Hatalı veya eksik alanlar var!";
            showAxiosError({message: message});
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let self = this;
        let result = validateComponent(self);
        this.setState({
            error: result.error
        });
        return result
    }

    handleEditDates(index, event, type) {
        let priceList = deepCopyObject(this.state.priceList);
        if (type === 'startDate') {
            if (!(typeof event === "string")) {
                let startDate = event.format("YYYY-MM-DDT00:00:00");
                let finishDate = event.clone().add(1, 'years').format('YYYY-MM-DDT23:59:59');

                priceList[index].startDate = startDate;
                priceList[index].expireDate = finishDate;
                this.setState({priceList});
            }
        } else {
            if (!(typeof event === "string")) {
                let finishDate = event.format("YYYY-MM-DDT23:59:59");
                priceList[index].expireDate = finishDate;
                this.setState({priceList});
            }
        }

    }

    onChange(e, index, key) {
        let priceList = deepCopyObject(this.state.priceList);
        priceList[index][key] = e.value;
        this.setState({priceList});
    }

    handleRemove(index) {
        let priceList = deepCopyObject(this.state.priceList);
        priceList.splice(index, 1);
        this.setState({priceList});
    }

    render() {
        let {priceList} = this.state;
        let selectOptions = [{value: 1, label: "Kontör(Adet)"}, {value: 2, label: defterUnitName(EntegratorConf.identifier) + "("+defterUnitNameShort(EntegratorConf.identifier)+")"}, {
            value: 3,
            label: "Arşiv Kasa"
        }];
        return (
            <div>
                <div className="col-sm-12">
                    <div className="tab-content">
                        <div>
                            <div>
                                <table className=""
                                       style={{textAlign: 'center', paddingBottom: "5px", width: "100%"}}>
                                    <thead>
                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                        <th width="5%">#</th>
                                        <th width="15%">Fiyat</th>
                                        <th width="10%">Miktar</th>
                                        <th width="10%">Birim Türü</th>
                                        <th width="15%">Başlangıç Tarihi</th>
                                        <th width="15%">Bitiş Tarihi</th>
                                        <th width="10%">İşlem</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {priceList.map((item, index) =>
                                        <tr key={index}>
                                            <td data-label={"#"}>{(index + 1).toString()}</td>
                                            <td data-label={"Fiyat"}>
                                                <div
                                                    className={"form-group" + this.validateClass("price_" + index)}>
                                                    <NumberFormat id={'price_' + index}
                                                                  value={item.price}
                                                                  isNumericString={true}
                                                                  allowNegative={false}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={2}
                                                                  maxLength="10"
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  placeholder="Fiyat Giriniz"
                                                                  renderText={value => {
                                                                      value.replace(/\./g, ',')
                                                                  }}
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "price"
                                                                  }, index, "price")}
                                                                  onBlur={() => this.validateField({
                                                                      target: {
                                                                          id: "price_" + index,
                                                                          dataset: {
                                                                              'vdata': "required",
                                                                              'vlength': "1,255"
                                                                          },
                                                                          value: item.price
                                                                      }
                                                                  })}
                                                                  ref={'price_' + index}
                                                                  inputProps={{
                                                                      id: 'price_' + index,
                                                                      dataset: {
                                                                          vdata: "required",
                                                                          vlength: "1,255",
                                                                          value: item.price
                                                                      }
                                                                  }}
                                                                  className="form-control"/>
                                                    {this.validateMessage("price_" + index) !== "" &&
                                                        <UncontrolledTooltip placement="right"
                                                                             target={"price_" + index} delay={0}>
                                                            {this.validateMessage("price_" + index)}
                                                        </UncontrolledTooltip>}
                                                </div>
                                            </td>
                                            <td data-label={"Miktar"}>
                                                <div
                                                    className={"form-group" + this.validateClass("quantity_" + index)}>
                                                    <NumberFormat id={'quantity_' + index}
                                                                  value={item.quantity}
                                                                  disabled={false}
                                                                  isNumericString={true}
                                                                  allowEmptyFormatting={false}
                                                                  decimalScale={2}
                                                                  thousandSeparator={'.'}
                                                                  decimalSeparator={','}
                                                                  displayType="input"
                                                                  placeholder="Miktar"
                                                                  maxLength="10"
                                                                  className="form-control"
                                                                  onValueChange={(e) => this.onChange({
                                                                      value: e.value,
                                                                      name: "quantity"
                                                                  }, index, "quantity")}
                                                    /></div>
                                            </td>
                                            <td data-label={"Birim Türü"}>
                                                <div
                                                    className={"form-group" + this.validateClass("uint_" + index)}>
                                                    <Select
                                                        id={'uint_' + index}
                                                        clearable={false}
                                                        placeholder="Birim Seçiniz.."
                                                        className="select-control"
                                                        value={item.unit}
                                                        onChange={(e) => e && this.onChange({
                                                            name: "unit",
                                                            value: e.value
                                                        }, index, "unit")}
                                                        options={selectOptions}
                                                    />
                                                </div>
                                            </td>
                                            <td data-label={"Başlangıç Tarihi"}>
                                                {<div
                                                    className={"form-group" + this.validateClass("tStartDate_" + index)}>
                                                    <Datetime locale="tr"
                                                              id={"tStartDate_" + index}
                                                              className="datepicker"
                                                              input={true}
                                                              inputProps={{
                                                                  id: 'tStartDate_' + index,
                                                                  dataset: {
                                                                      vlength: "1,255",
                                                                      value: item.startDate
                                                                  },
                                                                  readOnly: true
                                                              }}
                                                              onBlur={(momentObj) => this.validateField({
                                                                  target: {
                                                                      id: 'tStartDate_' + index,
                                                                      dataset: {
                                                                          'vdata': "required",
                                                                          'vlength': "1,255"
                                                                      },
                                                                      value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                                  }
                                                              })}
                                                              closeOnSelect={true}
                                                              value={item.startDate ? moment(item.startDate).format('DD-MM-YYYY') : null}
                                                              dateFormat="DD-MM-YYYY"
                                                              ref={"tStartDate_" + index}
                                                              isValidDate={(current) => valid(current, item.expireDate, 'startDate')}
                                                              timeFormat={false}
                                                              onChange={(e) => this.handleEditDates(index, e, 'startDate')}
                                                    />
                                                    {this.validateMessage("tStartDate_" + index) !== "" &&
                                                        <UncontrolledTooltip placement="right"
                                                                             target={"tStartDate_" + index}
                                                                             delay={0}>
                                                            {this.validateMessage("tStartDate_" + +index)}
                                                        </UncontrolledTooltip>}
                                                </div>}
                                            </td>
                                            <td data-label={"Bitiş Tarihi"}>{<div
                                                className={"form-group" + this.validateClass("tExpireDate_" + index)}>
                                                <Datetime locale="tr"
                                                          id={"tExpireDate_" + index}
                                                          className="datepicker"
                                                          input={true}
                                                          min={item.startDate ? moment(item.startDate).format('DD-MM-YYYY') : moment}
                                                          inputProps={{
                                                              id: 'tExpireDate_' + index,
                                                              dataset: {
                                                                  vlength: "1,255",
                                                                  value: item.expireDate
                                                              },
                                                              readOnly: true
                                                          }}
                                                          onBlur={(momentObj) => this.validateField({
                                                              target: {
                                                                  id: "tExpireDate_" + index,
                                                                  dataset: {
                                                                      'vdata': "required",
                                                                      'vlength': "1,255"
                                                                  },
                                                                  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                              }
                                                          })}
                                                          closeOnSelect={true}
                                                          value={item.expireDate ? moment(item.expireDate).format('DD-MM-YYYY') : null}
                                                          dateFormat="DD-MM-YYYY"
                                                          ref={"tExpireDate_" + index}
                                                          isValidDate={(current) => valid(current, item.startDate, 'expireDate')}
                                                          timeFormat={false}
                                                          onChange={(e) => this.handleEditDates(index, e, 'expireDate')}
                                                />
                                                {this.validateMessage("tExpireDate_" + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={"tExpireDate_" + index} delay={0}>
                                                        {this.validateMessage("tExpireDate_" + index)}
                                                    </UncontrolledTooltip>}
                                            </div>}</td>
                                            <td data-label={"İşlemler"}>
                                                <button type="button"
                                                        onClick={() => this.handleRemove(index)}
                                                        disabled={priceList.length < 2}
                                                        data-toggle="tooltip" data-placement="bottom"
                                                        title="Sil"
                                                        style={{background: 'linear-gradient(#ff3636b8, #ff3636b8)'}}
                                                        rel="tooltip" className="Btn btn-sm btn-icon">
                                                    <i className="fa fa-trash"/>
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                                <div className="row ">
                                    <div className="col-sm-12 ">
                                        <button type="button" onClick={() => this.addNewLine()}
                                                disabled={this.state.isLoading}
                                                style={{
                                                    background: ' linear-gradient(rgb(134 193 243), #1085d8)',
                                                    padding: '9px 45px 9px 20px'
                                                }}
                                                className="TekBtn ekle">Satır Ekle
                                        </button>
                                        <button type="button" disabled={this.state.isLoading} onClick={this.save}
                                                style={{padding: '9px 45px 9px 20px'}}
                                                className=" TekBtn kaydet pull-right">Kaydet
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default DistributorPriceList;